import React from 'react';
import { Carousel } from 'react-bootstrap';

const Banner = () => {
  return (
    <section id="banner" className="banner-section">
      <Carousel fade interval={5000}>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="/images/slider-01.jpg"
            alt="Pearl Jewelry"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="/images/slider-03.jpg"
            alt="Luxury Pearls"
          />
        </Carousel.Item>
      </Carousel>
    </section>
  );
};

export default Banner; 